import React from 'react';
import ChapterSummary from './ChapterSummary';
import { useState, createContext } from "react";
import './ChapterContent.scss';
import getYear from '../../utils/getYear';

export const CollapseContext = createContext();

const ChapterContent = ({ outline }) => {

    const [collapseToggle, setcollapseToggle] = useState(false);

    const handleSwitchChange = (event) => {
        setcollapseToggle(!collapseToggle);
    };

    let view = <ChapterSummary outline={outline} />
    return (
        <CollapseContext.Provider value={{collapseToggle, setcollapseToggle}}>
            <>
            {getYear() >= 2025 && 
                <>
                    <span className="collapse-checkbox-label">
                        <input
                            type="checkbox"
                            checked={collapseToggle}
                            onChange={handleSwitchChange}
                            className="collapse-checkbox"
                        />
                        All Text
                    </span> 
                </> 
            }            
            {view}
            </>
        </CollapseContext.Provider>
    )
}

export default ChapterContent